export enum SearchTypeEnum {
    TYPE_AHEAD = 1
}